import { AUTH_TOKEN } from './constants'
import { parseJSON } from './common'

export function setToken(token) {
	parseJSON(sessionStorage.setItem(AUTH_TOKEN, token))
}
export function getToken() {
	return sessionStorage.getItem(AUTH_TOKEN)
}
export function remoteToken() {
	return sessionStorage.removeItem(AUTH_TOKEN)
}
export function isAuth() {
	return getToken() === 'undefined' ? false : !!getToken()
}
